import { valueAsNumber } from './ParsingUtils';
import PropTransformer from './PropTransformer';
export default class StringToNumberPropTransformer extends PropTransformer {
    prop;
    constructor(prop) {
        super();
        this.prop = prop;
    }
    toGateway(data) {
        if (data[this.prop]) {
            return Number(data[this.prop]);
        }
    }
    fromGateway(value) {
        const result = {};
        const number = valueAsNumber(value);
        if (number !== undefined) {
            result[this.prop] = number;
        }
        return result;
    }
}
//# sourceMappingURL=StringToNumberPropTransformer.js.map